<template>
  <el-dialog :title="title" :visible.sync="show" width="600px">
    <div style="width: 100%; height: 100%;" v-loading="loading">
      <div class="w100 pl20 pr20 pt20 pb20">
        <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="应用名称" prop="name" style="min-width: 250px;">
            <el-input v-model="form.name" placeholder="请输入应用名称"></el-input>
          </el-form-item>
          <el-form-item label="应用对象" prop="obj" style="width: 100%; min-width: 250px;">
            <el-select v-model="form.obj" multiple placeholder="请选择应用对象" style="width: 100%; min-width: 250px;">
              <el-option v-for="item in prorData" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用链接" prop="linkUrl" style="min-width: 250px;">
            <el-input v-model="form.linkUrl" placeholder="请输入应用链接"></el-input>
          </el-form-item>

          <el-form-item label="应用类型" prop="type" style="min-width: 250px;">
            <el-select v-model="form.type" placeholder="请选择应用类型" style="width: 100%; min-width: 250px;">
              <el-option v-for="item in typeOpt" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用令牌" prop="appTokenName" style="min-width: 250px;">
            <el-input v-model="form.appTokenName" placeholder="请输入应用令牌"></el-input>
          </el-form-item>

          <el-form-item label="应用图标" prop="imgUrl" style="min-width: 250px;">
            <div style="display: flex; flex-direction: row; align-items: center;">
              <el-upload ref="upload" class="avatar-uploader" :action="uploadUrl" :headers="uploadHeader" accept=".png" :on-change="onChange" :on-success="onSuccess" :on-error="onError" :auto-upload="false" :show-file-list="false">
                <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <span style="font-size: 12px; color: #e6a23c; padding-left: 8px;">png格式，大小80*80像素，建议20KB以内.</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="show = false">取 消</el-button>
      <el-button v-if="!isUpData" @click="submitForm('ruleForm')" type="primary">保 存</el-button>
      <el-button v-else @click="submitForm('ruleForm')" type="primary">更 新</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppDialog",
  components: {},
  props: ["prorData"],
  data() {
    return {
      show: false,
      loading: false,
      title: "",
      thisId: "", // 当前数据的ID，用来判断新增、更新
      isUpData: false,
      uploadUrl: this.$http.defaults.baseURL + "/serveFile/upload", // 上传地址
      uploadHeader: {},
      typeOpt: [
        { label: "办事大厅应用", value: "office" },
        { label: "aws应用", value: "aws" },
        { label: "外站连接", value: "tokenUrl" },
        { label: "外部系统应用", value: "resultUrl" },
      ],
      form: {
        name: "",
        obj: [],
        linkUrl: "",
        imgUrl: "",
        type: "",
        imgId: "",
        appTokenName: "",
      },
      rules: {
        name: [{ required: true, message: "请输入应用名称", trigger: "blur" }],
        obj: [{ required: true, message: "请输选择应用对象", trigger: "blur" }],
        type: [
          { required: true, message: "请输选择应用类型", trigger: "blur" },
        ],
        linkUrl: [
          { required: true, message: "请输入应用链接", trigger: "blur" },
        ],
        imgUrl: [
          { required: true, message: "请选择传应用图标", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["userToken"]),
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 显示弹框
    dialogShow(id, name) {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields();

        // 判断是编辑还是新增
        if (id) {
          this.loading = true;
          this.isUpData = true;
          this.title = name + " 应用详情";
          this.getInfo(id);
        } else {
          this.thisId = "";
          this.title = "新增应用";
          this.isUpData = false;
        }
      });
    },

    // 获取详情
    getInfo(id) {
      this.$http
        .get("/app/appDetail?appId=" + id)
        .then((res) => {
          if (res.data.resCode === 0) {
            let data = res.data.resData;
            let obj = [];

            data.app.appTargetList.forEach((e) => {
              obj.push(e.id + "");
            });

            this.thisId = data.app.id;
            this.form.name = data.app.appName;
            this.form.obj = obj;
            this.form.linkUrl = data.app.appUrl;
            this.form.imgUrl = data.appIcon.fileUrl;
            this.form.imgId = data.appIcon.id;
            this.form.type = data.app.appType;
            this.form.appTokenName = data.app.appTokenName;
          } else {
            this.show = false;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 点击 提交
    submitForm(formName) {
      this.loading = true;
      // 验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 如果已有上传图标，就不需要在调图标上传方法
          if (this.form.imgId) {
            this.submitFn(this.form.imgId);
            return;
          }
          // 提交的时候上传文件
          this.$refs.upload.submit();
        } else {
          this.loading = false;
          return false;
        }
      });
    },

    // 提交方法
    submitFn(id) {
      let arrObj = [];

      this.form.obj.forEach((e) => {
        this.prorData.forEach((i) => {
          if (e === i.value) {
            arrObj.push({ id: e, targetName: i.label });
          }
        });
      });

      let data = {
        appName: this.form.name,
        appTarget: JSON.stringify(arrObj),
        appUrl: this.form.linkUrl,
        appIcon: id,
        appType: this.form.type,
        appTokenName: this.form.appTokenName,
      };

      // 如果有ID、调用更新接口
      if (this.thisId) {
        data.id = this.thisId;
        this.upDataFn(data);
        return;
      }

      this.$http
        .post("/app/addApp", this.$qs.stringify(data))
        .then(({ data }) => {
          if (data.resCode === 0) {
            this.show = false;
            this.$parent.initPage();
            this.$message.success("应用" + this.form.name + " 新增成功!");
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 更新方法
    upDataFn(data) {
      this.$http
        .post("/app/updateApp", this.$qs.stringify(data))
        .then(({ data }) => {
          if (data.resCode === 0) {
            this.show = false;
            this.$parent.initPage();
            this.$message.success("应用" + this.form.name + "更新成功!");
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 设置 图片选择框中显示图标
    onChange(file) {
      let arr = [];
      const isPNG = file.raw.type === "image/png";
      const isLt2M = file.size / 1024 < 21;

      if (!isPNG) {
        this.form.imgUrl = "";
        this.$message.error("上传应用图标只能是 PNG 格式!");
        return;
      }
      if (!isLt2M) {
        this.form.imgUrl = "";
        this.$message.error("上传应用图标大小不能超过 20KB!,请重新上传。");
        return;
      }

      // 变更图标之后重新赋值，保持只有有个图标
      arr.push(file);
      this.$refs.upload.uploadFiles = arr;

      this.form.imgId = ""; // 选择新图片，id要为空
      this.uploadHeader = {
        token: this.userToken,
        Authorization: "bearer " + this.$keycloak.token,
      }; // 设置上传的 headers token
      this.form.imgUrl = URL.createObjectURL(file.raw);
    },

    // 上传成功
    // 上传成功之后、设置 已上传图标的id;
    onSuccess(response) {
      this.$nextTick(() => {
        this.submitFn(response.resData[0]);
      });
    },

    // 上传错误
    onError() {
      this.$message.error("图标上传错误！");
      this.$nextTick(() => {
        this.form.imgUrl = "";
      });
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped>
.title {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f1f2f3;
  padding-bottom: 12px;
}

.title span {
  color: #409eff;
  font-size: 16px;
}

.el-form {
  padding-top: 20px;
}

.avatar-uploader {
  width: 32px;
  height: 32px;
  display: block;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.avatar-uploader .avatar {
  width: 32px;
  height: 32px;
  display: block;
}
</style>
